/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file guid.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * guid.js can not be copied and/or distributed
 * without the express permission of keni
 */

/**
 * Created by keni on 20/06/2017.
 * Little function for creating unique ids
 * @returns {string}
 */
export function guid() {
	// console.log('1',1);
	let proposedId = s4() + s4() + '-' + s4() + '-' + s4() + '-' +
		s4() + '-' + s4() + s4() + s4();
	if($('#'+proposedId).length > 0){
		guid();
	}
	return proposedId;
}

function s4() {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/guid.js